module.exports = __webpack_public_path__ + "media/mypage/images/icons/icon_myplofedit-9d0b33451ab16ed893b6b45757da1c8c.png";